/*
 *  全系列 restful api格式, 定义通用req对象
 *
 *  @author terrfly
 *  @site
 *  @date 2021/5/8 07:18
 */

import request from '@/http/request'

export const req = {

  // 通用列表查询接口
  list: (url, params) => {
    return request.request({ url: url, method: 'GET', params: params }, true, true, false)
  },

  // 通用新增接口
  add: (url, data) => {
    return request.request({ url: url, method: 'POST', data: data }, true, true, false)
  },

  // 通用查询单条数据接口
  getById: (url, bizId) => {
    return request.request({ url: url + '/' + bizId, method: 'GET' }, true, true, false)
  },

  // 通用修改接口
  updateById: (url, bizId, data) => {
    return request.request({ url: url + '/' + bizId, method: 'PUT', data: data }, true, true, false)
  },

  // 通用删除接口
  delById: (url, bizId) => {
    return request.request({ url: url + '/' + bizId, method: 'DELETE' }, true, true, false)
  },
  getList: (url, data) => {
    return request.request({ url: url, method: 'POST', data: data }, true, true, false)
  },
  updateByIdPost: (url, data) => {
    return request.request({ url: url, method: 'POST', data: data }, true, true, false)
  },
  delByIdPost: (url, bizId) => {
    return request.request({ url: url + '?id=' + bizId, method: 'DELETE' }, true, true, false)
  }
}

// 全系列 restful api格式 (全局loading方式)
export const reqLoad = {

  // 通用列表查询接口
  list: (url, params) => {
    return request.request({ url: url, method: 'GET', params: params }, true, true, true)
  },

  // 通用新增接口
  add: (url, data) => {
    return request.request({ url: url, method: 'POST', data: data }, true, true, true)
  },

  // 通用查询单条数据接口
  getById: (url, bizId) => {
    return request.request({ url: url + '/' + bizId, method: 'GET' }, true, true, true)
  },

  // 通用修改接口
  updateById: (url, bizId, data) => {
    return request.request({ url: url + '/' + bizId, method: 'PUT', data: data }, true, true, true)
  },

  // 通用删除接口
  delById: (url, bizId) => {
    return request.request({ url: url + '/' + bizId, method: 'DELETE' }, true, true, true)
  },
  delByIdPost: (url, data) => {
    return request.request({ url: url, method: 'DELETE', data: data }, true, true, true)
  }
}

/** 角色管理页面 **/
export const API_URL_ENT_LIST = '/api/sysEnts'
export const API_URL_ROLE_LIST = '/api/sysRoles'
export const API_URL_ROLE_ENT_RELA_LIST = '/api/sysRoleEntRelas'
export const API_URL_SYS_USER_LIST = '/api/sysUsers'
export const API_URL_USER_ROLE_RELA_LIST = '/api/sysUserRoleRelas'
/** 首页统计 **/
export const API_URL_MAIN_STATISTIC = 'api/mainChart'

/** 商户App管理 **/
export const API_URL_MCH_APP = '/api/mchApps'
/** 支付订单管理 **/
export const API_URL_PAY_ORDER_LIST = '/api/payOrder'
/** 代收订单管理 **/
export const API_URL_RECEIVE_ORDER_LIST = '/api/order/pay-in'
/** 代付订单管理 **/
export const API_URL_SEND_ORDER_LIST = '/api/order/pay-out'
/** 退款订单管理 **/
export const API_URL_REFUND_ORDER_LIST = '/api/refundOrder'
/** 支付方式列表 **/
// export const API_URL_PAYWAYS_LIST = '/api/payWays'
/** 商户支付参数配置 **/
export const API_URL_MCH_PAYCONFIGS_LIST = '/api/mch/payConfigs'
/** 商户支付通道配置 **/
export const API_URL_MCH_PAYPASSAGE_LIST = '/api/mch/payPassages'
/** 转账订单管理 **/
export const API_URL_TRANSFER_ORDER_LIST = '/api/transferOrders'
/** 充值订单管理 **/
export const API_URL_RECHARGE_ORDER_LIST = '/api/mch/recharge'

/** 分账组管理 **/
export const API_URL_DIVISION_RECEIVER_GROUP = '/api/divisionReceiverGroups'

/** 分账账号管理 **/
export const API_URL_DIVISION_RECEIVER = '/api/divisionReceivers'

/** 分账记录管理 **/
export const API_URL_PAY_ORDER_DIVISION_RECORD_LIST = '/api/division/records'

/** 上传图片/文件地址 **/
export const upload = {
  avatar: request.baseUrl + '/api/ossFiles/avatar',
  cert: request.baseUrl + '/api/ossFiles/cert'
}

const api = {
  user: '/user',
  role_list: '/role',
  service: '/service',
  permission: '/permission',
  permissionNoPager: '/permission/no-pager',
  orgTree: '/org/tree'
}

export default api

/** 获取权限树状结构图 **/
export function getEntTree () {
  return request.request({ url: '/api/sysEnts/showTree', method: 'GET' })
}

/** 更新用户角色信息 */
export function uSysUserRoleRela (sysUserId, roleIdList) {
  return request.request({
    url: 'api/sysUserRoleRelas/relas/' + sysUserId,
    method: 'POST',
    data: { roleIdListStr: JSON.stringify(roleIdList) }
  })
}

export function getRoleList (parameter) {
  return request({
    url: '/api/sysRoles',
    method: 'get',
    params: parameter
  })
}

/** 根据支付接口查询支付参数配置 **/
export function getMchPayConfigUnique (infoId, ifCode) {
  return request.request({
    url: '/api/mch/payConfigs/' + infoId + '/' + ifCode,
    method: 'get'
  })
}

/** 根据支付方式查询可用支付接口 **/
export function getAvailablePayInterfaceList (appId, wayCode) {
  return request.request({
    url: '/api/mch/payPassages/availablePayInterface/' + appId + '/' + wayCode,
    method: 'GET'
  })
}

export function getPayAmountWeek () {
  return request.request({
    url: API_URL_MAIN_STATISTIC + '/payAmountWeek',
    method: 'GET'
  })
}

export function getNumCount () {
  return request.request({
    url: API_URL_MAIN_STATISTIC + '/numCount',
    method: 'GET'
  })
}

export function getPayCount (parameter) {
  return request.request({
    url: API_URL_MAIN_STATISTIC + '/payCount',
    method: 'GET',
    params: parameter
  })
}

export function getPayType (parameter) {
  return request.request({
    url: API_URL_MAIN_STATISTIC + '/payTypeCount',
    method: 'GET',
    params: parameter
  })
}

export function getMainUserInfo () {
  return request.request({
    url: API_URL_MAIN_STATISTIC,
    method: 'GET'
  })
}

export function updateUserPass (parameter) {
  return request.request({
    url: '/api/current/modifyPwd',
    method: 'put',
    data: parameter
  })
}

export function updateUserInfo (parameter) {
  return request.request({
    url: '/api/current/user',
    method: 'put',
    data: parameter
  })
}

export function getUserInfo () {
  return request.request({
    url: '/api/current/user',
    method: 'get'
  })
}
// 代付｜最近7日交易数据
// /api/dashboard/transactions/week/pay get请求，无参数
export function getTransactionWeekPay () {
  return request.request({
    url: '/api/dashboard/transactions/week/pay',
    method: 'GET'
  })
}
// 代付｜总交易金额和总交易金额
// /api/dashboard/transactions/total/pay
export function getPayAmountTotal () {
  return request.request({
    url: '/api/dashboard/transactions/total/pay',
    method: 'GET'
  })
}

// 代收｜最近7日交易数据
// /api/dashboard/transactions/week/collect
export function getCollectAmountWeek () {
  return request.request({
    url: '/api/dashboard/transactions/week/collect',
    method: 'GET'
  })
}
// 代收｜总交易金额和总交易金额
// /api/dashboard/transactions/total/collect
export function getCollectAmountTotal () {
  return request.request({
    url: '/api/dashboard/transactions/total/collect',
    method: 'GET'
  })
}
// 交易统计
// /api/dashboard/transactions/statistics
export function getTransactionStatistics () {
  return request.request({
    url: '/api/dashboard/transactions/statistics',
    method: 'GET'
  })
}
// 用户总数量
// /api/dashboard/registered/users/count
export function getDashboardUsersCount () {
  return request.request({
    url: '/api/dashboard/registered/users/count',
    method: 'GET'
  })
}
/** 获取到webSocket的前缀 （ws://localhost） **/
export function getWebSocketPrefix () {
  // 获取网站域名 +  端口号
  let domain = document.location.protocol + '//' + document.location.host

  // 判断api_base_url 是否设置
  if (process.env.VUE_APP_API_BASE_URL && process.env.VUE_APP_API_BASE_URL !== '/') {
    domain = process.env.VUE_APP_API_BASE_URL
  }

  if (domain.startsWith('https:')) {
    return 'wss://' + domain.replace('https://', '')
  } else {
    return 'ws://' + domain.replace('http://', '')
  }
}

/** 查询支付宝授权地址URL **/
export function queryAlipayIsvsubMchAuthUrl (mchAppId) {
  return request.request({
    url: '/api/mch/payConfigs/alipayIsvsubMchAuthUrls/' + mchAppId,
    method: 'GET'
  })
}

/** 查询商户转账支出的接口 **/
export function queryMchTransferIfCode (appId) {
  return request.request({
    url: 'api/mchTransfers/ifCodes/' + appId,
    method: 'GET'
  })
}

/** 获取客户IDID二维码地址 **/
export function getChannelUserQrImgUrl (ifCode, appId, extParam) {
  return request.request({
    url: '/api/mchTransfers/channelUserId',
    method: 'GET',
    params: { ifCode, appId, extParam }
  })
}

/** 转账 **/
export function doTransfer (parameter) {
  return request.request({
    url: '/api/mchTransfers/doTransfer',
    method: 'POST',
    data: parameter
  }, true, true, true)
}

/** 查询当前应用支持的支付接口 **/
export function getIfCodeByAppId (appId) {
  return request.request({
    url: '/api/mch/payConfigs/ifCodes/' + appId,
    method: 'GET'
  }, true, true, true)
}

/** 退款接口 */
export function payOrderRefund (payOrderId, refundAmount, refundReason) {
  return request.request({
    url: '/api/payOrder/refunds/' + payOrderId,
    method: 'POST',
    data: { refundAmount, refundReason }
  })
}

/** 分账重试 */
export function resendDivision (recordId) {
  return request.request({
    url: '/api/division/records/resend/' + recordId,
    method: 'POST'
  })
}

// 更新操作员谷歌验证码
export function updateUserGoogleVerify (recordId) {
  return request.request({
    url: '/api/sysUsers/updateGoogleVerify/' + recordId,
    method: 'PUT'
  })
}

// 代付订单统计
export function getPayOutOrderListCount (params) {
  return request.request({
    url: '/api/order/pay-out/listCount',
    method: 'GET',
    params: {
      ...params
    }
  })
}

// 代收订单统计
export function getPayInOrderListCount (params) {
  return request.request({
    url: '/api/order/pay-in/listCount',
    method: 'GET',
    params: {
      ...params
    }
  })
}

// 订单导出
// 代付 订单导出(异步导出，文件上传至OSS)
// /api/order/pay-out/excel
export const searchPayOutOrderExportList = (data) => {
  return request.request({
    url: '/api/order/pay-out/excel',
    method: 'GET',
    params: data
  })
}
// 订单导出历史记录
// /api/order/pay-out/exportList
export const getPayOutOrderExportList = (data) => {
  return request.request({
    url: '/api/order/pay-out/exportList',
    method: 'GET',
    params: data
  })
}

// 代收订单 订单导出(异步导出，文件上传至OSS)
// /api/order/pay-in/excel
export const searchPayInOrderExportList = (data) => {
  return request.request({
    url: '/api/order/pay-in/excel',
    method: 'GET',
    params: data
  })
}

// 订单导出历史记录
// /api/order/pay-in/exportList
export const getPayInOrderExportList = (data) => {
  return request.request({
    url: '/api/order/pay-in/exportList',
    method: 'GET',
    params: data
  })
}
